import { getSDKConfig } from '../lib/getSDKConfig';

export const errorFallback = () => {
  const { title, subTitle, description, buttonTitle } = errorContent();

  const ERROR_HTML = `<div class="swipe_error_msg" style="width: 100%; height: 100%; z-index: 1;
  background: black; position: relative;">
      <div style="font-family: Arial, sans-serif; background-color: #343a40; color: #ffffff;
      border: 1px solid #495057; padding: 15px 0px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      width: calc(100% - 30px); position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
      text-align: center;">
          <h1 style="margin: 0 0 10px 0; font-size: 24px; color: #ffffff;">${title}</h1>
          <p style="margin: 0 0 10px 0; font-size: 18px; color: #f8f9fa;">${subTitle}</p>
          <p style="margin: 0; font-size: 16px; color: #adb5bd;">${description}</p>
          <button onclick="location.reload()" style="background-color: #007bff; color: #ffffff;
          border: none; padding: 10px 20px; border-radius: 5px; cursor: pointer; font-size: 16px;
          margin-top: 15px;">${buttonTitle}</button>
      </div>
  </div>`;
  return ERROR_HTML;
};

export function errorContent() {
  const swipeSDKConfig = getSDKConfig();

  const language: string = swipeSDKConfig?.locale?.language ?? 'en';

  const errorMessages =
    swipeSDKConfig?.locale?.translations?.[language] ??
    swipeSDKConfig?.locale?.translations?.['en'] ??
    {};

  const title: string =
    errorMessages['error.title'] ?? errorMessages.title ?? 'Error';

  const subTitle: string =
    errorMessages['error.subTitle'] ??
    errorMessages.subTitle ??
    'Something went wrong.';

  const description: string =
    errorMessages['error.description'] ??
    errorMessages.description ??
    'Please try again later.';

  const buttonTitle: string =
    errorMessages['error.buttonTitle'] ??
    errorMessages?.buttonTitle ??
    'Reload';

  return {
    title,
    subTitle,
    description,
    buttonTitle,
  };
}

export const errorResponse = () => {
  return { gameData: '', placeHolderDom: errorFallback() };
};
